const PayableReceivableCashFlowType = {
    PAYABLE: 'PAYABLE',
    RECEIVABLE: 'RECEIVABLE'
}

export default PayableReceivableCashFlowType;